const getters = {
  listaUnidadesProcedencia: (state) => state.listaUnidadesProcedencia
}

export default getters
